import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/service/createaction";
import Servicelist from "./servicelist";

const Service = () => {
    const { recaller, setrecaller, initDispatch, clear } = useContext(GlobalContext);
    const [service_name, setservice_name] = useState();
    const [service_price, setservice_price] = useState();
    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);

    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                <h1 className="text-2xl font-bold text-slate-800">خزمەتگوزاری</h1>
                <p className="text-sm text-slate-400 mt-0.5">ناساندن و بەڕێوەبردنی خزمەتگوزاریەکان</p>
                </div>
            </div>

            {/* Add New Expense Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                    <div className="w-full">
                        <label
                            className={
                            error
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                        >
                            ناوی خزمەتگوزاری
                        </label>
                        <input
                            className={
                                error
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            type="text"
                            value={service_name}
                            onChange={(val) => setservice_name(val.target.value)}
                            onFocus={() => seterror(false)}
                        />
                    </div>

                    {/* Service Price Input */}
                    <div className="w-full">
                        <label
                            className={
                                error1
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                        >
                            نرخی خزمەتگوزاری
                        </label>
                        <input
                            className={
                                error1
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            type="number"
                            value={service_price}
                            onChange={(val) => setservice_price(val.target.value)}
                            onFocus={() => seterror1(false)}
                        />
                    </div>

                    {/* Add Button */}
                    <div className="w-full">
                        <button
                            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                            onClick={() => {
                                if (service_name == "" || !service_name) {
                                    seterror(true);
                                    return false;
                                }
                                if (Number(service_price) < 0 || !service_price) {
                                    seterror1(true);
                                    return false;
                                }
                                createaction(service_name, service_price)(recaller)(setrecaller)(initDispatch)(clear);
                            }}
                        >
                            زیادکردن
                        </button>
                    </div>
                </div>
            </div>

            {/* Service List */}
            <div className="mt-8">
                <Servicelist />
            </div>
        </div>
    );
};

export default Service;